import { DesignEditorTabName } from '@gelato-api-ui/core/design-editor/types/design-editor-tab-name.enum';
import { DesignEditorTabsVisibilityConfig } from '@gelato-api-ui/design-editor/types/design-editor-tabs-visibility-config';

export const defaultDesignEditorTabsVisibilityConfig: DesignEditorTabsVisibilityConfig = {
  [DesignEditorTabName.PRODUCT]: false,
  [DesignEditorTabName.VARIANTS]: false,
  [DesignEditorTabName.LAYERS]: true,
  [DesignEditorTabName.GALLERY]: true,
  [DesignEditorTabName.TEXTS]: true,
  [DesignEditorTabName.SHAPES]: false,
  [DesignEditorTabName.TEMPLATES]: false,
  [DesignEditorTabName.WARNINGS]: true,
  [DesignEditorTabName.LAYOUTS]: true,
  [DesignEditorTabName.SETTINGS]: true,
  [DesignEditorTabName.ADDONS]: false,
  [DesignEditorTabName.SHUTTERSTOCK]: false,
  [DesignEditorTabName.SCENE]: false,
  [DesignEditorTabName.PLACEHOLDER]: false,
  [DesignEditorTabName.MOCKUP]: false,
};
